import React from 'react';
import { Switch, Route } from 'react-router-dom';
import DashBoardSideBar from '../../../adminpanel/components/AdminSideBar';
import BreadCrumb from '../../../adminpanel/components/commonComponents/BreadCrumb';
import DataConnector from './dataConnector/DataConnector';
import LoadData from './loadData/LoadData';
import TableDetails from './connectionData/TableDetails';
import ViewRawData from './connectionData/ViewRawData';
import APIRequest from './APIRequest';
import EmailIntegrate from './EmailIntegration/EmailIntegrate';
import SavedModelComponent from './SavedModel/SavedModelComponent';


const ParentRoute = ({ }) => {

    const menu_array = {
        "home": { "name": "home", "label": 'Home', "link": "/admin/home", "icon": "home", "showMenu": false },
        // "datasets":{ "name": "datasets","label": 'Datasets', "link": "/admin/dataset", "icon": 'upload' },
        "dataConnector": { "name": "dataConnector", "label": 'Data Connectors', "link": "/adminpanel/v2/dataconnector", "icon": "sliders", "showMenu": false },
        "addConnection": { "name": "addConnection", "label": 'Add Connection', "link": "/adminpanel/v2/initialize_connector", "icon": "plus-circle", "showMenu": false },
        "connectionsData": { "name": "connectionsData", "label": 'All Connections Data', "link": "/adminpanel/v2/view_connection_data", "icon": "server", "showMenu": false },
        "apiRequest": { "name": "apiRequest", "label": 'Request Logs', "link": "/adminpanel/v2/apirequest/admin", "icon": "activity", "showMenu": false },
        "dataSettings": {
            "name": "dataSettings", "label": 'Data Settings', "link": "javascript:void(0);", "icon": "database",
            "children": {
                // "data": { "name": "db_management", "label": 'Upload Files (Storage)', "link": "/admin/upload_data", "header": "Data", "showMenu": false },
                "createView": {
                    "name": "createView", "label": 'Create Dataset', "link": "/admin/datasets", "header": "Data", "showMenu": false
                },
                "listView": { "name": "datasets", "label": 'Merge Tables', "link": "/admin/merge", "showMenu": false },
                "savedModel": {"name": "savedModel", "label": "Saved Models", "link": "/adminpanel/v2/savedModel", "showMenu": false}
            }
        },

        "buildDataModal": {
            "name": "buildDataModal", "label": 'Ad-Hoc Settings', "link": "javascript:void(0);", "icon": "pie-chart",
            "children": {
                "column_definition": { "name": "column_definition", "label": 'Column Definition', "link": "/admin/model_data", "showMenu": true },

                "dimensions": { "name": "dimensions", "label": 'Add Segments', "link": "/admin/dimensions", "showMenu": true },
                "metrics": { "name": "metrics", "label": 'Add Metrics', "link": "/admin/metric", "header": "Configure Ad-Hoc BI", "showMenu": true },
                "metricformat": { "name": "metricformat", "label": 'Metric Formatting', "link": "/admin/metricformat", "showMenu": true },
            }
        },
        "cognitiveSettings": {
            "name": "cognitiveSettings", "label": 'Cognitive Settings', "link": "javascript:void(0);", "icon": "search",
            "children": {
                "synonyms": {
                    "name": "synonyms", "label": 'Configure Search', "link": "/admin/synonym?type=property", "showMenu": true
                    // "children": {
                    //     "synonym_property": { "name": "synonym_property", "label": "Dimension Synonyms", "link": "/admin/synonym?type=property", "icon": 'paperclip', "showMenu": true},
                    //     "synonym_metric": { "name": "synonym_metric", "label": "Metric Synonyms", "link": "/admin/synonym?type=metric", "icon": 'crop', "showMenu": true }
                    // }
                },

                "configInsight": {
                    "name": "insight", "label": 'Configure Insight', "link": "/admin/configureInsight", "showMenu": true
                },
            }
        },
        "users": {
            "name": "users", "label": 'User Management', "link": "javascript:void(0);", "icon": "users",
            "children": {
                "manageUsers": { "name": "manageUsers", "label": "Manage Users", "link": "/admin/users", "showMenu": false },
                "managePermissions": { "name": "managePermissions", "label": "User Permissions", "link": "/admin/useraccess", "showMenu": false }
            }
        },
        "generalsettings": { "name": "generalsettings", "label": 'General Settings', "link": "/admin/generalsettings", "icon": "settings" },
        "authIntegrate": { "name": "authIntegrate", "label": 'Configure Authentication', "link": "/admin/authIntegrate", "icon": "settings", "showMenu": false },
        //"emailIntegrate": { "name": "emailIntegrate", "label": 'Configure Email', "link": "/adminpanel/v2/emailIntegrate", "icon": "settings", "showMenu": false },
        "App": { "name": "app", "label": 'Rockmetric App', "link": "/", "icon": "home", "showMenu": false }
    };
    jQuery('.content-body').css("width", `100%`);
    screen_width = jQuery(window).width() 

    const setTitle = () => {
        var pathName = location.pathname;
        pathName = pathName.split("/");
        if (pathName.length == 4 || pathName.length == 5)
            pathName = pathName[3];
        else pathName = pathName[pathName.length - 1];
        let title = "";
        switch (pathName) {
            case "dataconnector":
                title = "Data Connectors"
                break;
            case "initialize_connector":
                title = "Add Connection"
                break;
            case "view_connection_data":
                title = `All Connections`
                break;
            case "apirequest":
                title = `Request Logs`
                break;
            case "savedModel":
                title = `Saved Models`
                break;
        }
        document.title = `${title} | Cognitive Analytics Platform`;
    }

    return (
        <React.Fragment>
            <DashBoardSideBar match={{ location: location }} menuOptions={menu_array} />
            {setTitle()}
            <div className= {`${screen_width<mobile_width? ' ht-100v pd-0':'content ht-100v pd-0 adminParentMargin'}`}>
                {<nav class="content-header d-none mobile-d-none bg-white bd-b-1" style={{ borderBottomWidth: "1px"}}> </nav>}
                {/* <div className="content-header">
                    <div className="content-search">
                        <i data-feather="search"></i>
                        <input type="search" className="form-control" placeholder="Search..." />
                    </div>
                </div> */}
                <div className="content-body" ref={(node) => {
                        if (node) {
                            node.style.setProperty("padding", "25px", "important");
                        }
                    }}>
                    <BreadCrumb menuOptions={menu_array} pathname={location.pathname} />
                    <Switch>
                        {/* <Route exact path={`/adminpanel/v2`} component={LatestAdminPanel} /> */}
                        <Route exact path={`/adminpanel/v2/dataconnector`} component={DataConnector} />
                        <Route exact path={`/adminpanel/v2/initialize_connector`} component={LoadData} />
                        <Route exact path={`/adminpanel/v2/view_connection_data`} component={TableDetails} />
                        <Route path="/adminpanel/v2/view_connection_data/:dbName/:tableName/:connectionId" component={TableDetails} />
                        <Route path={"/adminpanel/v2/view_raw_data/:dbName/:tableName/:fileName"} component={ViewRawData} />
                        <Route path={"/adminpanel/v2/view_raw_data/:dbName/:tableName"} component={ViewRawData} />
                        <Route exact path={`/adminpanel/v2/apirequest/:requested_from`} component={APIRequest} />
                        <Route exact path={`/adminpanel/v2/emailIntegrate`} component={EmailIntegrate} />
                        <Route exact path={`/adminpanel/v2/savedModel`} component={SavedModelComponent} />
                    </Switch>
                </div>
            </div>
            {/* <Toast /> */}
        </React.Fragment>
    )
}

export default ParentRoute;